import { h, Component } from 'preact';
import { IEmptyState, IPaginationProps } from '../sgwt-super-header.types';

export default class Pagination extends Component<IPaginationProps, IEmptyState> {
  constructor(props: IPaginationProps) {
    super(props);
  }

  changePage(newPage: number) {
    if (newPage > 0 && newPage <= this.props.pagesCount && newPage !== this.props.currentPage) {
      this.props.onPageChange(newPage);
    }
  }

  render(props: IPaginationProps): JSX.Element {
    const firstPage = props.currentPage === 1;
    const lastPage = props.currentPage === props.pagesCount;

    let indexes = [];
    const minIndex = Math.max(1, props.currentPage - 2);
    const maxIndex = Math.min(props.pagesCount, props.currentPage + 2);
    for (let i = minIndex; i <= maxIndex; i++) {
      indexes.push(i);
    }
    const items = indexes.map((page: number) => {
      const liClass = page === props.currentPage ? 'active' : '';
      return <li class={liClass}><span onClick={() => this.changePage(page)}>{page}</span></li>;
    });

    return (
      <nav>
        <ul class="pagination">
          <li class={`${firstPage ? 'disabled' : ''} first`}>
            <span onClick={() => this.changePage(1)}>
              <i class="fa fa-angle-double-left"/>
              <span class="sr-only">{props.labels.first}</span>
            </span>
          </li>
          <li class={`${firstPage ? 'disabled' : ''} previous`}>
            <span onClick={() => this.changePage(props.currentPage - 1)}>
              <i class="fa fa-angle-left"/>
              <span class="sr-only">{props.labels.previous}</span>
            </span>
          </li>
          {items}
          <li class={`${lastPage ? 'disabled' : ''} next`}>
            <span onClick={() => this.changePage(props.currentPage + 1)}>
              <i class="fa fa-angle-right"/>
              <span class="sr-only">{props.labels.next}</span>
            </span>
          </li>
          <li class={`${lastPage ? 'disabled' : ''} last`}>
            <span onClick={() => this.changePage(props.pagesCount)}>
              <i class="fa fa-angle-double-right"/>
              <span class="sr-only">{props.labels.last}</span>
            </span>
          </li>
        </ul>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/components/Pagination.tsx